
import { DocumentSize, VaultFilesBoxEndIcons, VaultFilesEndTag, VaultPendingFilesBoxHeader, VaultPendingFilesBoxWrapper } from "./VaultPendingFilesModal.styles"
import { VaultPendingFileBox } from "./VaultPendingFilesModal.styles"
import { VaultPendingFileBoxFileIconTextWrapper } from "./VaultPendingFilesModal.styles"
import { DocumentIconWrapper } from "./VaultPendingFilesModal.styles"
import { DocumentDetailsWrapper } from "./VaultPendingFilesModal.styles"
import { DocumentTitle } from "./VaultPendingFilesModal.styles"
import { VaultPendingFileBoxDescriptionSizeWrapper } from "./VaultPendingFilesModal.styles"
import { VaultPendingFileBoxDescriptionSizeWrapperDot } from "./VaultPendingFilesModal.styles"
import { getFileSizeString, getFileType, VaultTooltip } from "../../utils/Utils";
import { LoadingOutlined } from "@ant-design/icons";
import { VaultDocumentRejectedIcon, VaultDuplicatedIcon, VaultEraseIcon, VaultRectVIcon } from "../../assets/icons";
import { useStore } from "../../../app/data/root.store"

export const VaultPendingFilesBox = ({ filesPending, onDelete, isDeleting }) => {
    const { userStore: { isWelcome } } = useStore();

    if (!filesPending || filesPending.length === 0) {
        return null;
    }

    const isSingleFile = (filesPending.length === 1);

    return (
        <VaultPendingFilesBoxWrapper>
            <VaultPendingFilesBoxHeader>
                {`Uploading ${filesPending.length} file${filesPending.length > 1 ? 's' : ''}`}
            </VaultPendingFilesBoxHeader>
            {
                filesPending.map(file => (
                    <VaultPendingFileBox key={file.id}>
                        <VaultPendingFileBoxFileIconTextWrapper>
                            <DocumentIconWrapper>{getFileType(file.originalName)}</DocumentIconWrapper>
                            <DocumentDetailsWrapper>
                                <DocumentTitle>{file.originalName}</DocumentTitle>
                                <VaultPendingFileBoxDescriptionSizeWrapper>
                                    <DocumentSize>{getFileSizeString(file.size)}</DocumentSize>
                                    {
                                        !isSingleFile && file.llmResultMetadata?.description &&
                                        <VaultTooltip title={file.llmResultMetadata?.description}                                            >
                                            <VaultPendingFileBoxDescriptionSizeWrapperDot>{file.llmResultMetadata?.description}</VaultPendingFileBoxDescriptionSizeWrapperDot>
                                        </VaultTooltip>

                                    }
                                </VaultPendingFileBoxDescriptionSizeWrapper>
                            </DocumentDetailsWrapper>
                            {
                                ('in process' === file.llmStatus) ?
                                    <LoadingOutlined style={{ fontSize: '24px' }} />
                                    :
                                    <VaultFilesBoxEndIcons>
                                        <EndTag status={file.llmStatus} isWelcome={isWelcome} isDuplicate={file.isDuplicate} />
                                        <DeleteIcon isDeleting={isDeleting} onDelete={() => onDelete(file.id)} />
                                    </VaultFilesBoxEndIcons>
                            }
                        </VaultPendingFileBoxFileIconTextWrapper>
                    </VaultPendingFileBox>
                ))
            }
        </VaultPendingFilesBoxWrapper>
    )
}

const EndTag = ({ status, isWelcome, isDuplicate }) => {
    let bgColor, Icon, text, tooltipText;

    if (isDuplicate) {
        tooltipText = "This file appears to be a duplicate based on its content. It already exists in your Vault.";
        bgColor = "#F6BB49";
        Icon = VaultDuplicatedIcon;
        text = "Duplicate data";
    } else if (isWelcome && status === 'rejected') {
        tooltipText = "AI rejected this file because it does not contain any portfolio-related data.";
        bgColor = "#FF947C";
        Icon = VaultDocumentRejectedIcon;
        text = "Rejected";
    } else {
        tooltipText = "Your file was successfully uploaded and is now ready for deep analysis.";
        bgColor = "#72E1AC";
        Icon = VaultRectVIcon;
        text = "Ready";
    }

    return (
        <VaultTooltip title={tooltipText}>
            <VaultFilesEndTag bgColor={bgColor}>
                <Icon />
                <div>{text}</div>
            </VaultFilesEndTag>
        </VaultTooltip>
    );
};

const DeleteIcon = ({ isDeleting, onDelete }) => {
    if (isDeleting) {
        return <LoadingOutlined style={{ fontSize: '24px' }} />;
    }

    return (
        <VaultTooltip title="Delete file">
            <div onClick={onDelete} style={{ display: 'flex' }}>
                <VaultEraseIcon />
            </div>
        </VaultTooltip>
    );
}
